import * as React from 'react';
import { useSelector } from 'react-redux';

import { MortgagedPropertyLabels } from '../../components/MortgagedPropertyLabels';
import { selectAgentLists } from '../../selectors/offerData/selectAgentLists';
import { useApplicationContext } from '../ApplicationContext';

export const MortgagedPropertyLabelsContainer: React.FC = () => {
  const agentLists = useSelector(selectAgentLists);
  const { config } = useApplicationContext();
  const mortgagedProperties = config.get<Record<string, string>>('sellingTypes.agentLists');

  const texts = React.useMemo(
    () => agentLists.map(agentList => mortgagedProperties?.[agentList]).filter(Boolean) as string[],
    [agentLists, mortgagedProperties],
  );

  if (!mortgagedProperties || agentLists.length === 0) {
    return null;
  }

  return <MortgagedPropertyLabels texts={texts} />;
};
